import {
  CommercialSettingsUpdate,
  AdminCommandResult,
  SuperAdminBusinessList,
  SuperAdminSession,
} from "../models/superAdmin.model";
import { pythonApiClient } from "./python-http-client.service";

export const superAdminApi = {
  me: async () =>
    (await pythonApiClient.get<SuperAdminSession>("/api/super-admin/me")).data,
  businesses: async (search = "") =>
    (await pythonApiClient.get<SuperAdminBusinessList>("/api/super-admin/businesses", { params: { search } })).data,
  businessSettings: async (settingsId: string) =>
    (await pythonApiClient.get<Record<string, any>>(`/api/super-admin/businesses/${encodeURIComponent(settingsId)}`)).data,
  updateBusinessSettings: async (settingsId: string, settings: Record<string, any>) =>
    (await pythonApiClient.put<Record<string, any>>(`/api/super-admin/businesses/${encodeURIComponent(settingsId)}`, settings)).data,
  updateCommercialSettings: async (settingsId: string, settings: CommercialSettingsUpdate) =>
    (await pythonApiClient.patch<CommercialSettingsUpdate>(`/api/super-admin/businesses/${encodeURIComponent(settingsId)}/commercial-settings`, settings)).data,
  agentSettings: async (settingsId: string) =>
    (await pythonApiClient.get<Record<string, any>>(`/api/super-admin/businesses/${encodeURIComponent(settingsId)}/agent`)).data,
  updateAgentSettings: async (settingsId: string, settings: Record<string, any>) =>
    (await pythonApiClient.put<Record<string, any>>(`/api/super-admin/businesses/${encodeURIComponent(settingsId)}/agent`, settings)).data,
  executeAdminCommand: async (settingsId: string, command: string) =>
    (await pythonApiClient.post<AdminCommandResult>(`/api/super-admin/businesses/${encodeURIComponent(settingsId)}/admin-command`, { command })).data,
};
